module.exports = __webpack_public_path__ + "img/ve.fae3dc0b.jpg";